/** Public editorial contact (also used in Organization JSON-LD). */
export const SITE_CONTACT_EMAIL = 'ashkelonnews@gmail.com';
